import React, { useState } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { useSnackbar } from 'notistack'
import { useConfirm } from "material-ui-confirm";
import axios from "axios";
import BasePopup from "../../../Components/Base/BasePopup";
//import UsuarioCadastroPopup from "./UsuarioCadastroPopup";
import DataGridBuscaComponent from "../../../Components/Forms/DataGridBuscaComponent";
import { Motorista } from "../../../Models/Cadastros/Motorista/Motorista";
import MotoristaCadastroPopup from "./MotoristaCadastroPopup";

const MotoristaPesquisaPopup = (props: any) => {
    const [openCadastroPopup, setOpenCadastroPopup] = useState(false);
    const [openPopupConfirm, setOpenPopupConfirm] = useState(false);
    const [motorista, setMotorista] = useState<any>(new Motorista());
    const closePopupAction = () => setOpenPopupConfirm(false);
    const { enqueueSnackbar } = useSnackbar();
    const confirm = useConfirm();

    function openCadastroPopupEventCallback() {
        setMotorista(new Motorista());
        setOpenCadastroPopup(true);
    }

    async function editarMotorista (id: any) {
        let response: any = await axios.get(`motoristas/${id}`);
        setMotorista(response.data);
        setOpenCadastroPopup(true);
    };

    async function solicitaExcluirMotorista(id: any) {
        await confirm({ title: "Deseja realmente apagar este registro?" });
        // todo: Adiciona codigo de delete
        enqueueSnackbar(`ID = ${id}`, {variant: 'success'});
    };

    const columns: any[] = [
        { dataIndex: 'nome', title: 'Nome', minWidth: 200, flex: 0.6, },
        { dataIndex: 'cpf', title: 'CPF', minWidth: 200, flex: 0.4, },
    ];
    
    return (
        <div>
            <BasePopup title="Motoristas" isOpen={props.isOpen} onClose={props.onClose} onClickFirstButtonPopupCallback={openCadastroPopupEventCallback}>
                <DataGridBuscaComponent apiBusca="buscaMotoristas" columns={columns} onEditAction={editarMotorista} onDeleteAction={solicitaExcluirMotorista} fieldId='id' />
            </BasePopup>

            {openCadastroPopup ? <MotoristaCadastroPopup isOpen={openCadastroPopup} onClose={() => setOpenCadastroPopup(false)} motorista={motorista} /> : ''}
        </div>
    );
}

export default MotoristaPesquisaPopup;
